/* BG COM : bienvenue après connexion (snippets/bgcom-bienvenue). Sorti du HTML le 03/10/2026, chargé en defer.
   Connecté : données dans <script type="application/json" id="BgcomWelcomeData"> ; déconnecté : on note l'heure d'un clic de connexion. */
if(document.getElementById('BgcomWelcomeData')){
  (function(){
    var el=document.getElementById('BgcomWelcomeData'); if(!el) return; var D; try{ D=JSON.parse(el.textContent); }catch(e){ return; }
    try{
      if(sessionStorage.getItem('bgcomWelcomed')===String(D.id))return;
      var at=+(localStorage.getItem('bgcomLoginAt')||0),fresh=at&&(Date.now()-at)<7200000;
      var ref=document.referrer||'',fromAccount=/^https:\/\/(shopify\.com|account\.[^\/]+)\//.test(ref);
      if(!fresh&&!fromAccount)return;
      localStorage.removeItem('bgcomLoginAt');sessionStorage.setItem('bgcomWelcomed',String(D.id));
    }catch(e){return;}
    function show(){
      if(!window.bgcomCelebrate)return;
      var name=D.first?D.first+' !':'parmi nous !';
      var espace=function(){location.href=D.espace||D.account;};
      if(D.pro){
        window.bgcomCelebrate({img:D.img,line1:'Bon retour,',spray:name,
          p1Before:D.co?'Les tarifs pro de':'Vos tarifs pro sont actifs :',stamp:D.co||'',p1After:D.co?'sont actifs : les prix affichés sont vos prix.':'les prix affichés sont vos prix.',
          p2:D.terms==='30jfdm'?'Paiement à 30 jours fin de mois sur vos commandes. Vos favoris, factures et encours sont dans votre espace pro.':'Vos favoris, commandes et factures sont dans votre espace pro.',
          primary:{label:'Continuer mes achats'},secondary:{label:'Mon espace pro',onClick:espace}});
      }else{
        window.bgcomCelebrate({img:D.img,line1:'Vous êtes connecté,',spray:name,
          p1Before:'Votre espace client est prêt : commandes, factures et adresses au même endroit.',p1After:'',
          p2:'Professionnel ? Demandez votre compte pro pour voir vos tarifs et payer à 30 jours.',
          primary:{label:'Demander un compte pro',href:D.proUrl},secondary:{label:'Continuer mes achats'}});
      }
    }
    function load(){
      var l=document.createElement('link');l.rel='stylesheet';l.href=D.css;document.head.appendChild(l);
      var s=document.createElement('script');s.src=D.js;s.async=true;s.onload=function(){setTimeout(show,350);};document.head.appendChild(s);
    }
    if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load);else load();
  })();
  }else{
  (function(){
    if(window.BGWL)return;window.BGWL=1;
    function mark(){try{localStorage.setItem('bgcomLoginAt',String(Date.now()));}catch(e){}}
    document.addEventListener('click',function(e){var a=e.target.closest&&e.target.closest('a[href*="/customer_authentication/login"],a[href*="/account/login"],[data-bgh-login-link]');if(a)mark();},true);
    document.addEventListener('submit',function(e){var f=e.target;if(f&&f.getAttribute&&/customer_authentication\/login|account\/login/.test(f.getAttribute('action')||''))mark();},true);
  })();
  }
